import styled, { css } from "styled-components";
import { colors, font, radius, shadow } from "../../../styles/theme/tokens";

// Форма «Відмітка про урок» у нових стилях платформи (токени styles/theme/tokens.js)

export const Form = styled.div`
  display: flex;
  flex-direction: column;
  gap: 22px;
  width: 100%;
  max-width: 640px;
  margin: 0 auto;
  padding: 28px;
  border-radius: ${radius.xl};
  font-family: ${font.text};
  color: ${colors.ink};
  background: ${colors.surface};
  box-shadow: ${shadow.card};

  @media (max-width: 600px) {
    padding: 18px 16px;
    border-radius: ${radius.lg};
  }
`;

// Шапка з учнем
export const StudentCard = styled.div`
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 14px 16px;
  border-radius: ${radius.lg};
  background: ${colors.brandSoft};
`;

export const Avatar = styled.span`
  display: grid;
  place-items: center;
  flex-shrink: 0;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  font-size: 18px;
  font-weight: 800;
  color: #FFFFFF;
  background: ${colors.brand};
`;

export const StudentInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;

  b {
    font-size: 17px;
    font-weight: 800;
  }

  small {
    font-size: 13px;
    color: ${colors.muted};
  }
`;

export const LevelPill = styled.span`
  margin-left: auto;
  padding: 6px 12px;
  border-radius: ${radius.pill};
  font-size: 13px;
  font-weight: 700;
  white-space: nowrap;
  color: ${colors.brandDeep};
  background: ${colors.surface};
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const Label = styled.span`
  font-size: 13px;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: ${colors.muted};
`;

// Вибір типу уроку — дві великі картки, щоб було видно
export const Types = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;

  @media (max-width: 480px) {
    grid-template-columns: 1fr;
  }
`;

export const Type = styled.button`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 16px;
  border-radius: ${radius.lg};
  border: 2px solid ${(props) => (props.$active ? colors.brandDeep : colors.line)};
  font-family: ${font.text};
  text-align: left;
  color: ${(props) => (props.$active ? "#FFFFFF" : colors.ink)};
  background: ${(props) => (props.$active ? colors.brand : colors.surface)};
  box-shadow: ${(props) => (props.$active ? shadow.button(colors.brandDeep) : "none")};
  cursor: pointer;
  transition: border-color 0.15s ease, background 0.15s ease, transform 0.15s ease;

  &:hover {
    border-color: ${colors.brand};
    transform: translateY(-1px);
  }

  svg {
    flex-shrink: 0;
    color: ${(props) => (props.$active ? "#FFFFFF" : colors.brand)};
  }

  b {
    display: block;
    font-size: 16px;
    font-weight: 800;
  }

  small {
    display: block;
    margin-top: 2px;
    font-size: 12px;
    color: ${(props) => (props.$active ? "rgba(255, 255, 255, 0.85)" : colors.muted)};
  }
`;

export const TypeCheck = styled.span`
  display: grid;
  place-items: center;
  flex-shrink: 0;
  width: 22px;
  height: 22px;
  margin-left: auto;
  border-radius: 50%;
  border: 2px solid ${(props) => (props.$active ? "#FFFFFF" : colors.line)};
  color: ${colors.brand};
  background: ${(props) => (props.$active ? "#FFFFFF" : "transparent")};
`;

// Список варіантів під полем
export const DropdownWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  max-height: 320px;
  margin-top: -8px;
  padding: 10px;
  overflow-y: auto;
  border: 2px solid ${colors.brand};
  border-top: none;
  border-radius: 0 0 ${radius.md} ${radius.md};
  background: ${colors.surface};
`;

export const Select = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 11px 14px;
  border-radius: ${radius.sm};
  cursor: pointer;
  color: ${(props) => (props.selected ? colors.brandDeep : colors.ink)};
  background: ${(props) => (props.selected ? colors.brandSoft : "transparent")};
  transition: background 0.15s ease;

  &:hover {
    background: ${colors.brandSoft};
  }
`;

export const Option = styled.p`
  font-size: 15px;
  font-weight: ${(props) => (props.$bold ? 800 : 600)};
`;

export const Input = styled.input`
  padding: 10px 12px;
  border-radius: ${radius.sm};
  border: 1.5px solid ${colors.line};
  font-family: ${font.text};
  font-size: 14px;
  color: ${colors.ink};
  background: ${colors.bg};
  outline: none;

  &:focus {
    border-color: ${colors.brand};
  }

  &::placeholder {
    color: ${colors.muted};
  }
`;

export const TextArea = styled.textarea`
  min-height: 92px;
  padding: 14px 16px;
  border-radius: ${radius.md};
  border: 1.5px solid ${colors.line};
  font-family: ${font.text};
  font-size: 15px;
  line-height: 1.5;
  color: ${colors.ink};
  background: ${colors.surface};
  resize: vertical;
  outline: none;
  transition: border-color 0.15s ease;

  &:focus {
    border-color: ${colors.brand};
  }

  &::placeholder {
    color: ${colors.muted};
  }
`;

export const Button = styled.button`
  align-self: center;
  min-width: 240px;
  margin-top: 6px;
  padding: 14px 28px;
  border-radius: ${radius.pill};
  font-family: ${font.text};
  font-size: 16px;
  font-weight: 800;
  color: #FFFFFF;
  background: ${colors.brand};
  box-shadow: ${shadow.button(colors.brandDeep)};
  cursor: pointer;
  transition: transform 0.1s ease, box-shadow 0.1s ease;

  &:active {
    transform: translateY(3px);
    box-shadow: ${shadow.button("transparent")};
  }

  @media (max-width: 480px) {
    width: 100%;
  }
`;

export const Message = styled.p`
  padding: 12px 16px;
  border-radius: ${radius.md};
  font-size: 14px;
  font-weight: 700;
  text-align: center;
  ${(props) =>
    props.isSuccess
      ? css`color: ${colors.success}; background: ${colors.successSoft};`
      : css`color: ${colors.danger}; background: ${colors.dangerSoft};`}
`;

export const LoaderWrapper = styled.div`
  display: flex;
  justify-content: center;

  svg path {
    fill: none !important;
  }
`;

// Підказка наступного уроку платформи
export const Next = styled.button`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
  width: 100%;
  padding: 10px 14px;
  border-radius: ${radius.md};
  border: 2px solid ${colors.amber};
  font-family: ${font.text};
  text-align: left;
  color: ${colors.ink};
  background: ${colors.amberSoft};
  cursor: pointer;

  span {
    font-size: 12px;
    font-weight: 800;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    color: ${colors.amberDeep};
  }

  b {
    font-size: 15px;
  }
`;
